import React, { useState, useContext } from 'react';
import slugify from 'slugify';

import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';

import { FilterMenu, IFilterMenuProps } from 'src/pages/CatalogPage/components/FilterMenu/FilterMenu';
import { IAuctionMappings } from 'src/pages/CatalogPage/Catalog.i';

import { Accordion, AccordionItem, Badge, Button, cn, Modal, NotificationBadge, RadioGroup, Tag } from '@riac/design-system';

import { Spinner } from '@riac/design-system';

import { useOverlayTriggerState } from '@react-stately/overlays';
import { OverlayContainer } from '@react-aria/overlays';
import { useDebounce } from '@uidotdev/usehooks';
import { getAppliedFilters } from 'src/pages/CatalogPage/components/FiltersSetDialog/FiltersSetDialog';


export const FiltersMobileMenu = ({
  facets,
  updateFilter,
  mappings,
  collections,
  searchInput,
  searchBusy,
  searchName,
  sessions,
}: IFilterMenuProps) => {
  const { keywords } = searchInput;
  const filtersModalOverlayState = useOverlayTriggerState({});
  const appliedFilters = getAppliedFilters(searchInput, mappings.session);

  const debouncedIsOpen = useDebounce(filtersModalOverlayState.isOpen, 5);
  const debouncedIsOpenClosing = useDebounce(filtersModalOverlayState.isOpen, 250);

  const filterCount = (keywords.length > 0 ? 1 : 0) + appliedFilters.length;

  return (
    <div>
      <div>
        <Button size='md' variant='secondary' onPress = {() => filtersModalOverlayState.open()}>
          <div className='flex flex-row gap-2 items-center'>
            Filters
            {filterCount > 0 && <NotificationBadge count={filterCount} max={20}/>}
          </div>
        </Button>
      </div>
      <OverlayContainer>
        <Modal
          isOpen={filtersModalOverlayState.isOpen || debouncedIsOpenClosing}
          isDismissable
          showCloseButton
          title='Filters'
          onClose={() => filtersModalOverlayState.close()}
          fullHeight
          type='full'
          className={cn('bg-opacity-0 transition-all duration-300', debouncedIsOpen ? 'bg-opacity-80' : '')}
          dialogClassName={cn(
            'md:max-w-96 transition-all duration-200 ease-in-out',
            debouncedIsOpen ? 'translate-x-0' : '-translate-x-full',
          )}
          footerButtons={<>
            <Button variant='secondary' className='mr-20 md:mr-0' onPress={() => filtersModalOverlayState.close()}>Close</Button>
          </>}
        >
          <div className='pt-1'/>
          <FilterMenu
            collections={collections}
            mappings={mappings}
            searchInput={searchInput}
            searchBusy={searchBusy}
            facets={facets}
            updateFilter={updateFilter}
            searchName={searchName}
            showOne
          />
        </Modal>
      </OverlayContainer>
    </div>
  );
};
